export default "__VITE_ASSET__fccb6517__"